<div class="sidebar" [ngClass]="!isCollapsed ? 'sidebar-not-collapsed' : ''">
    <div class="logo-container">
        <img class="menu-icon" src="assets/icons/menu.svg" alt="Menu" (click)="toggleCollapsed()">
        <a class="sidebar-logo" routerLink="/home" @fadeInOut>
            <img src="assets\images\logo_analitica_horizontal.svg" *ngIf="!isCollapsed && !isMobile" alt="Novaventa">
            <img class="logo-sm" src="assets\images\logo_analitica.png" *ngIf="isCollapsed || isMobile" alt="Novaventa">
        </a>
    </div>
    <ul class="sidebar-nav" *ngIf="routes && routes.length>0">
        <li class="sidebar-nav-item" *ngFor="let route of routes">
            <ng-container *ngIf="!route.subroutes else subroutes">
                <a class="sidebar-nav-link" [routerLink]="[route.path]" routerLinkActive="active">
                    <img class="sidebar-nav-icon" [src]="route.icon" [alt]="route.name">
                    <div class="sidebar-nav-text" @fadeInOut *ngIf="!isCollapsed">{{route.name}}</div>
                </a>
            </ng-container>
            <ng-template #subroutes>
                <div routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                    <a class="sidebar-nav-link expanded collapsed" data-bs-toggle="collapse"
                        [href]="'#'+getTrimmedName(route.name)" role="button" aria-expanded="false"
                        [attr.aria-controls]="route.name" (click)="closeCollapsed()">
                        <img class="sidebar-nav-icon" [src]="route.icon" [alt]="route.name">
                        <div class="sidebar-nav-text" @fadeInOut *ngIf="!isCollapsed">{{route.name}}</div>
                        <fa-icon class="arrow-icon" [icon]="faCaretDown"></fa-icon>
                    </a>
                    <div class="collapse" [id]="getTrimmedName(route.name)">
                        <ul class="sidebar-nav-subitems-container">
                            <li class="sidebar-nav-subitem" *ngFor="let subroute of route.subroutes">
                                <a [routerLink]=" [route.path+subroute.path]" (click)="toggleCollapsed()">
                                    {{subroute.name}}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </ng-template>
        </li>
    </ul>
</div>